/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createMortgageGetResponseFromDiscriminatorValue, serializeMortgagePostRequest, type MortgageGetResponse, type MortgagePostRequest } from '../models';
// @ts-ignore
import { type WithMortgageItemRequestBuilder, WithMortgageItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { OverviewRequestBuilderRequestsMetadata, type OverviewRequestBuilder } from './overview';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /mortgages
 */
export interface MortgagesRequestBuilder extends BaseRequestBuilder<MortgagesRequestBuilder> {
    /**
     * The overview property
     */
    get overview(): OverviewRequestBuilder;
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.mortgages.item collection
     * @param mortgageId The Guid identifier of the mortgage to retrieve
     * @returns {WithMortgageItemRequestBuilder}
     */
     byMortgageId(mortgageId: Guid) : WithMortgageItemRequestBuilder;
    /**
     * Retrieves a list of all mortgages
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<MortgageGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<MortgageGetResponse[] | undefined>;
    /**
     * Creates a new mortgage
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: MortgagePostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * Retrieves a list of all mortgages
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a new mortgage
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MortgagePostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const MortgagesRequestBuilderUriTemplate = "{+baseurl}/mortgages";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MortgagesRequestBuilderNavigationMetadata: Record<Exclude<keyof MortgagesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byMortgageId: {
        requestsMetadata: WithMortgageItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["mortgageId"],
    },
    overview: {
        requestsMetadata: OverviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const MortgagesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MortgagesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createMortgageGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: MortgagesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeMortgagePostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
